/**
 * @fileoverview Header component for the Loan Dashboard application
 * @version 1.0.0
 * 
 * @component Header
 * @description Renders the main header section of the application containing the company logo and title
 * 
 * @example
 * // Basic usage
 * import Header from './Header';
 * 
 * function App() {
 *   return (
 *     <div>
 *       <Header />
 *       {//Other components }
 *     </div>
 *   );
 * }
 * 
 * @returns {JSX.Element} Header component with logo placeholder and application title
 */

import React, { useState, useEffect } from 'react';
import logoLight from '../assets/img/logo-light.svg';
import logoDark from '../assets/img/logo-dark.svg';
import user from '../assets/img/users/1.jpg';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { HiOutlineHome } from "react-icons/hi2";
import { HiMiniTableCells } from "react-icons/hi2";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ResetPassword from '../pages/Modal/reset-password'
import { FaUserTie } from "react-icons/fa6";
import Button from 'react-bootstrap/Button';
import SwitchAccount from '../components/switch-account';
import { ToastContainer, toast } from "react-toastify";
const Header = ({ usermappingDetails, getRolesAndRights }) => {
    const [userRights] = useState(JSON.parse(localStorage.getItem("UserRights")));
    const [rolesAndRights] = useState(JSON.parse(localStorage.getItem("RolesAndRights")));
    console.log(localStorage.getItem("RolesAndRights"),'RolesAndRights')
    console.log(localStorage.getItem("UserRights"),'userRights')

    const [darkMode, setDarkMode] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const [resetpassword, setResetPassword] = useState(false);
    const closeResetPawwrod = () => setResetPassword(false);
    const showResetPassword = () => setResetPassword(true);

    // Check if the dark mode is already in localStorage
    useEffect(() => {
        const savedMode = localStorage.getItem("darkMode");
        if (savedMode === "true") {
            setDarkMode(true);
            document.body.classList.add("dark-mode");
        }
    }, []);

    // Toggle theme function
    const toggleTheme = () => {
        setDarkMode(!darkMode);
        document.body.classList.toggle("dark-mode");

        // Save theme preference to localStorage
        localStorage.setItem("darkMode", !darkMode);
    };

    const [isChecked, setIsChecked] = useState(false);
    const handleToggle = () => {
        setIsChecked(prevChecked => !prevChecked);
    };

    //  const checkbox1 = document.getElementById("checkbox1")
    //  checkbox1.addEventListener("change", () => {
    //    document.body.classList.toggle("dark")
    //  })
    const goToDashboard = () => {
        navigate('/dashboard');

    };
    const goToAdmin = () => {
        navigate('/admin');

    };
    const goToLogin = () => {
        // localStorage.clear();
        navigate('/logout');
    }
    const TooltipTop = ({ id, children, title }) => (
        <OverlayTrigger placement='top' overlay={<Tooltip id={id}>{title}</Tooltip>}>
            <span>{children}</span>
        </OverlayTrigger>
    );
    const TooltipBottom = ({ id, children, title }) => (
        <OverlayTrigger placement='bottom' overlay={<Tooltip id={id}>{title}</Tooltip>}>
            <span>{children}</span>
        </OverlayTrigger>
    );
    const TooltipLeft = ({ id, children, title }) => (
        <OverlayTrigger placement='left' overlay={<Tooltip id={id}>{title}</Tooltip>}>
            <span>{children}</span>
        </OverlayTrigger>
    );
    const TooltipRight = ({ id, children, title }) => (
        <OverlayTrigger placement='right' overlay={<Tooltip id={id}>{title}</Tooltip>}>
            <span>{children}</span>
        </OverlayTrigger>
    )
    // Switch Account 
    const [switchAccount, setSwitchAccount] = useState(false);
    const goToSwitchAccount = () => setSwitchAccount(true);
    const closeSwitchAccount = () => setSwitchAccount(false);
    const hasRightsToAdmin = () => {
        if (rolesAndRights !== null) {
            let rightID = rolesAndRights?.AllRights?.find(el => el.DisplayName.toLowerCase().trim() == "admin")?.RightId;
            if (JSON.parse(localStorage.getItem("UserRights")).some(el => el.RightId == rightID)) {
                return JSON.parse(localStorage.getItem("UserRights"))?.find(el => el.RightId == rightID).RightValue == 1 ? true : false;
            }
        }
    }
    // Switch Account 
    let clientdetails = JSON.parse(localStorage.getItem('CurrentMapping'));
    console.log(clientdetails);

    return (
        // Main header container with header class
        <>
            <header className="app-header">

                <div class="main-header-container container-fluid">
                    <div class="header-content-left">
                        <div class="header-element">
                            <div class="header-logo">
                                <a className='logo-light'><img src={logoLight} role="img" aria-label="Company logo" /></a>
                                <a className='logo-dark'><img src={logoDark} role="img" aria-label="Company logo" /></a>
                            </div>
                        </div>


                        <div class="header-element ms-5">
                            <div className="navbar-collapse">
                                <ul className="navbar-nav">
                                    {/* Dashboard is always visible */}
                                    <li className="nav-item">
                                        <a
                                            className={`nav-link ${location.pathname === '/dashboard' ? 'active' : ''}`}
                                            style={{ cursor: 'pointer' }}
                                            aria-current="page"
                                            onClick={goToDashboard}
                                        >
                                            <i className="ri-home-3-line"></i> Dashboard
                                        </a>
                                    </li>

                                    {/* Show Admin only on /admin */}
                                    {location.pathname === '/admin' && (
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${location.pathname === '/admin' ? 'active' : ''}`}
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => navigate('/admin')}
                                            >
                                                <i class="ri-group-line"></i> Admin
                                            </a>
                                        </li>
                                    )}

                                    {/* Show Loan Decision Info only on /general-information */}
                                    {location.pathname === '/general-information' && (
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${location.pathname === '/general-information' ? 'active' : ''}`}
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => navigate('/general-information')}
                                            >
                                                <i className="ri-file-list-2-line"></i> Loan Decision Info
                                            </a>
                                        </li>
                                    )}
                                </ul>

                            </div>
                        </div>
                    </div>
                    <div className="header-content-right">
                        <div className='header-element hdr-tbl'>
                            <table class="m-0 table"><tbody><tr><td class="fw-bold"><span class="circle"></span>UCN</td><td>:</td><td>{clientdetails.UseCaseName}</td><td>&nbsp;</td><td class="fw-bold"><span class="circle"></span>CN</td><td>:</td><td>{clientdetails.ClientName}</td></tr></tbody></table>
                        </div>
                        <div className="header-element header-theme-mode">

                            <a style={{ cursor: "pointer" }} onClick={toggleTheme} className='header-link'>
                                {darkMode ?
                                    <TooltipLeft title="Click to view Light Theme"><i className="ri-sun-fill fs-18"></i></TooltipLeft>
                                    :
                                    <TooltipLeft title="Click to view Dark Theme"><i className="ri-moon-fill fs-18"></i></TooltipLeft>
                                }
                            </a>

                        </div>

                        <div class="header-element main-profile-user">
                            <span style={{ marginTop: '13px', marginLeft: '10px' }}>Welcome <b style={{ marginRight: '5px' }}>{localStorage.getItem("FirstName") === "undefined" ? "welcome" : localStorage.getItem("FirstName")} {localStorage.getItem("LastName") === "undefined" ? "User" : localStorage.getItem("LastName")}</b></span>


                            <a style={{ padding: '0px', margin: '0px' }} className="header-link dropdown-toggle" role="button"
                                data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false"> <div class="d-flex align-items-center">
                                    <div>
                                        <Button variant="outline-primary" size='sm'>
                                            <FaUserTie style={{ fontSize: '16px' }} />
                                        </Button>
                                        {/* <i class="ri-account-circle-fill fs-4"></i> */}
                                        {/* <img src={user} role="img" aria-label="User"
                                    class="rounded-circle" />  */}
                                    </div>
                                    {/* <div class="my-auto">
                                    <h6 class="fw-semibold mb-0 lh-1 fs-14">Name</h6> 
                                    <span class="op-7 fw-normal d-block fs-11 text-muted">Role</span>
                                </div> */}
                                </div></a>
                            <ul className="dropdown-menu dropdown-menu-end" style={{ cursor: "pointer" }} aria-labelledby="navbarDropdown">
                                {hasRightsToAdmin() && <li><a className="dropdown-item" onClick={goToAdmin}><i class="ri-user-line me-1"></i> Admin</a></li>}
                                {location.pathname === '/dashboard' && (<li><a className="dropdown-item" onClick={goToSwitchAccount}><i class="ri-loop-left-line me-1"></i> Switch Account</a></li>)}
                                <li><a className="dropdown-item" ><i class="ri-settings-2-line me-1"></i> Settings</a></li>
                                

                                <li>
                                    <hr className="dropdown-divider" />
                                </li>
                                <li><a className="dropdown-item" onClick={showResetPassword}><i class="ri-reset-left-fill me-1"></i> Reset Password</a></li>
                                <li><a className="dropdown-item" onClick={goToLogin}><i class="ri-logout-box-r-line me-1"></i> Logout</a></li>
                            </ul>


                        </div>



                    </div>
                </div>

                <nav className="sb-topnav navbar navbar-expand d-none">
                    {/* Placeholder div for company logo with accessibility attributes */}
                    <a className="navbar-brand " >

                        <img src={logoLight} role="img"
                            aria-label="Company logo" /></a>

                    <div className="collapse navbar-collapse d-none">
                        <ul className="navbar-nav me-auto ">
                            <li className="nav-item">
                                <a className="nav-link" aria-current="page" >Link 1</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link active" >Link </a>
                            </li>
                        </ul>
                    </div>

                    <div class="header-element header-theme-mode">
                        <a aria-label="anchor" href="javascript:void(0);" class="header-link layout-setting"> <span class="light-layout">
                            <i class="fe fe-moon header-link-icon"></i>
                        </span> <span class="dark-layout">
                                <i class="fe fe-sun header-link-icon"></i>
                            </span> </a>

                    </div>


                    {/* Main application title */}
                    <div className="d-none d-md-inline-block form-inline ms-auto me-0 me-md-2 my-2 my-md-0">
                        client
                    </div>

                    <ul className="navbar-nav ms-auto ms-md-0">
                        <li className="nav-item dropdown">
                            <a className="btn btn-sm btn-outline-primary dropdown-toggle1" id="navbarDropdown" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false"> <i className="ri-user-line"></i></a>
                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                                <li><a className="dropdown-item" >Themes</a></li>
                                <li><a className="dropdown-item" >Settings</a></li>
                                <li><a className="dropdown-item" >Reports</a></li>
                                <li><a className="dropdown-item" >Admin</a></li>
                                <li>
                                    <hr className="dropdown-divider" />
                                </li>
                                <li><a className="dropdown-item" >Exit Module</a></li>
                                <li><a className="dropdown-item" >Logout</a></li>
                            </ul>
                        </li>
                    </ul>
                </nav>



            </header>
            <ResetPassword show={resetpassword}
                handleClose={closeResetPawwrod} />
            <SwitchAccount show={switchAccount} handleClose={closeSwitchAccount} usermappingDetails={usermappingDetails} getRolesAndRights={getRolesAndRights} />
        </>
    );
};


export default Header;
